import { DirectionProvider } from '@radix-ui/react-direction';
import { useTranslation } from 'react-i18next';
import { LANGUAGES, type LanguageCode } from '@/lib/i18n/registry';

/** Tells menus, dialogs, tabs and sliders the active reading direction. */
export function I18nDirectionProvider({ children }: { children: React.ReactNode }) {
  const { i18n } = useTranslation();
  const dir = LANGUAGES[(i18n.language as LanguageCode)]?.dir ?? 'ltr';
  return <DirectionProvider dir={dir}>{children}</DirectionProvider>;
}
